import React from 'react';
import './WhyChooseUs.css';

const features = [
    {
        icon: 'fa-solid fa-tags',
        title: 'Best Price Guarantee',
        description: 'We offer the most competitive prices in the market without compromising on quality or luxury.'
    },
    {
        icon: 'fa-solid fa-hotel',
        title: 'Dom & Int Hotel Booking',
        description: 'Expertly curated hotel selections, from cozy boutiques to luxury resorts, both locally and globally.'
    },
    {
        icon: 'fa-solid fa-map-marked-alt',
        title: 'Customized Tour Packages',
        description: 'Your trip, your way. We tailor every itinerary to match your unique interests and travel style.'
    },
    {
        icon: 'fa-solid fa-briefcase',
        title: 'Comprehensive Travel Services',
        description: 'A one-stop shop for all your travel needs—flights, visas, insurance, and local transportation.'
    }
];

const WhyChooseUs = () => {
    return (
        <section className="why-choose-us">
            <div className="wcu-container">
                <div className="wcu-layout">
                    {/* Left Side: Text and Headings */}
                    <div className="wcu-content">
                        <span className="wcu-label">Our Advantage</span>
                        <h2 className="wcu-title">Why Travel with <span className="highlight">Silvery Sky Holidays?</span></h2>
                        <p className="wcu-description">
                            With over a decade of experience in the travel industry, we pride ourselves on providing
                            exceptional service and creating unforgettable memories for our travelers.
                        </p>

                        <div className="wcu-stats">
                            <div className="stat-item">
                                <span className="stat-number">10k+</span>
                                <span className="stat-text">Happy Travelers</span>
                            </div>
                            <div className="stat-item">
                                <span className="stat-number">500+</span>
                                <span className="stat-text">Destinations</span>
                            </div>
                        </div>
                    </div>

                    {/* Right Side: Feature Cards */}
                    <div className="wcu-grid">
                        {features.map((feature, index) => (
                            <div key={index} className="feature-card">
                                <div className="feature-icon">
                                    <i className={feature.icon}></i>
                                </div>
                                <div className="feature-text">
                                    <h3>{feature.title}</h3>
                                    <p>{feature.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Decorative Background Elements */}
            <div className="bg-blob blob-1"></div>
            <div className="bg-blob blob-2"></div>
        </section>
    );
};

export default WhyChooseUs;
